import { Box } from '@mui/material';
import { WorkData } from 'assets/config';
import buildexDashboard from 'assets/img/caseStudy/buildex/buildex-dashboard-by-osperb-.jpg';
import buildexStorefront from 'assets/img/caseStudy/buildex/akl-final1.mp4';
import aklCatagory from 'assets/img/caseStudy/buildex/akl-catagory.mp4';
import groupVideo from 'assets/img/caseStudy/buildex/group-video.mp4';
import buildexOrders from 'assets/img/caseStudy/buildex/orders-duldex.jpg';
import buildexMap from 'assets/img/caseStudy/buildex/buildex-stoes-map-.jpg';
import buildexLoadingImg from 'assets/img/caseStudy/buildex/loading_img.png';
import buildexMobile from 'assets/img/caseStudy/buildex/Akl-mobile-screen.mp4';
import buildexDashboard1 from 'assets/img/caseStudy/buildex/Buildex-dashboard-.jpg';
import Buildex_video_home from 'assets/img/caseStudy/buildex/akl-first.mp4';

import startingImage from 'assets/img/caseStudy/buildex/image.jpg';

import {
  FigureWithCaption,
  BulletList,
  ListWithHeader,
  SectionDescription,
  SectionHeading,
  SectionTitle,
  LargeHeading,
  SectionBox,
} from 'components/CaseStudy/CaseStudyUtils';
import DiscussProjectSection from 'components/CaseStudy/elements/DiscussProjectSection';
import { generateCaseStudySchema, generateOrganizationSchema } from 'components/CaseStudy/SEOUtils';
import { E_COMMERCE_STYLES } from 'components/ECommerce/config';
import FeaturedCaseStudies from 'components/mobileLanding/FeaturedCaseStudies';
import VideoPlayer from 'components/VideoPlayer';
import useDevice from 'hooks/useDevice';
import { lazy, Suspense, useMemo } from 'react';
import { Helmet } from 'react-helmet';

const DefaultNavbar = lazy(() => import('../../components/DefaultNavbar'));
const MetaData = lazy(() => import('../../MetaData'));

const CSBuildex = () => {
  const { screenWidth, isMobile } = useDevice();
  const PreLoad = (
    <div className="h-screen w-100 flex items-center justify-center bg-black">
      {/* <h3 className="text-osperb-blue">Osperb</h3> */}
    </div>
  );

  const featuredProjects = useMemo(() => WorkData.slice(0, 3), []);

  const caseStudySchema = useMemo(() => {
    return generateCaseStudySchema({
      title: 'Custom-Coded Retail Enterprise E-Commerce | SAP ERP Ready',
      description:
        'How Osperb delivered custom-coded enterprise e-commerce for Al khalili Buildex - Oman. large catalog performance, microservices architecture, SAP ERP alignment, Bank Muscat payment gateway, VAT logic, and admin-driven pages.',
      image: buildexDashboard,
      author: 'Osperb',
      organization: 'Osperb',
    });
  }, []);

  const organizationSchema = useMemo(() => generateOrganizationSchema(), []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(caseStudySchema)}</script>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>

      <MetaData
        title={'Custom-Coded Retail Enterprise E-Commerce | SAP ERP Ready'}
        content={
          'How Osperb delivered custom-coded enterprise e-commerce for Al khalili Buildex - Oman. large catalog performance, microservices architecture, SAP ERP alignment, Bank Muscat payment gateway, VAT logic, and admin-driven pages.'
        }
        description={
          'How Osperb delivered custom-coded enterprise e-commerce for Al khalili Buildex - Oman. large catalog performance, microservices architecture, SAP ERP alignment, Bank Muscat payment gateway, VAT logic, and admin-driven pages.'
        }
        keyword={
          'enterprise e commerce case study, custom ecommerce development, custom coded ecommerce platform, gcc ecommerce development for gcc dubai oman saudi qatar, oman ecommerce app, enterprise ecommerce website, microservices ecommerce, sap erp ecommerce integration, sap id mapping, bank muscat payment gateway integration, arabic english ecommerce, vat ready checkout, click and collect ecommerce, b2c ecommerce system, scalable ecommerce architecture'
        }
      />

      <Suspense fallback={PreLoad}>
        <DefaultNavbar />
      </Suspense>

      <VideoPlayer
        src={'https://www.youtube.com/watch?v=dRnayEIW76w'}
        autoPlay={true}
        loop={true}
        muted={true}
        controls={false}
        pointerEvents="none"
        loadingImage={buildexLoadingImg}
        sx={{ borderRadius: 0, mt: 0 }}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          pt: 2,
          px: { xs: 2, sm: 3, md: 4 },
        }}
        maxWidth={E_COMMERCE_STYLES.container.maxWidthTabletLg}
        margin={E_COMMERCE_STYLES.container.mx}
      >
        <SectionBox mt={0}>

          <LargeHeading mt={0}>
            How we built a custom enterprise e-commerce platform for Al Khalili Group—designed for
            large catalogs, SAP ID mapping for ERP sync, and a scalable architecture
          </LargeHeading>

          <ListWithHeader
            header="Project snapshot"
            items={[
              <>
                <b>Client</b>: Buildex Stores (Al Khalili United Enterprises LLC), Oman
              </>,
              <>
                <b>Model</b>: B2C e-commerce (enterprise catalog + rule-based backend)
              </>,
              <>
                <b>Core deliverables</b>: Storefront + Admin Control Panel + Member/Sub-admin Panels
                + Rule-based backend
              </>,
              <>
                <b>Website</b>: buildexstores.com
              </>,
            ]}
          />

          <SectionDescription mt={{ xs: '24px', md: '40px' }}>
            {`Buildex Stores is a trusted retail brand in Oman under the Al Khalili Group, with a strong physical presence across the country. They needed more than a normal e-commerce website—because their large catalog, regional tax requirements, bilingual (Arabic/English) customer journeys, and multiple fulfillment models demanded an enterprise-grade system. Osperb built a custom enterprise e-commerce ecosystem with an optimized customer storefront and a powerful admin and sub-admin control layer. The platform supports Arabic and English shopping experiences, OMR pricing, VAT-ready tax calculation for both items and shipping, loyalty tiers, and special purchase flows like preorder and enquiry. Operations stay scalable through bulk uploads, export-ready reporting, role-based permissions, and flexible fulfillment workflows including delivery and pickup options.`}
          </SectionDescription>

          <FigureWithCaption
            src={buildexMap}
            caption="Buildex Stores Map"
            title='Buildex Stores Map'
            alt='Buildex Stores Map'
          />

          <SectionBox mt={{ xs: '50px', md: '100px' }}>
            <SectionTitle variant="xs">The challenge</SectionTitle>
            <SectionHeading title={`Why Buildex Couldn't Use a "Normal" E-commerce Platform`} />

            <SectionDescription>
              Omani customers value quality, reliability, and trusted local brands—especially for
              safety and construction-related products. The brand already had <b>trust, reach,</b>{' '}
              and <b>product depth</b> offline.
            </SectionDescription>

            <SectionDescription>
              The challenge was transferring that trust into an online experience without breaking
              under scale
            </SectionDescription>

            <SectionDescription>
              Buildex needed a platform that could handle <b>enterprise complexity</b> without
              sacrificing customer simplicity.
            </SectionDescription>

            <BulletList
              items={[
                <>
                  <b>Arabic & English</b> journeys with region-specific UX
                </>,
                <>
                  <b>OMR pricing</b> with detailed tax breakdowns (item + shipping logic)
                </>,
                <>
                  Large catalogs with <b>complex variants</b>, images, and IDs
                </>,
                <>
                  Special product journeys: <b>Preorder</b> and <b>Enquiry-based</b> items
                </>,
                <>
                  <b>Tier-based loyalty</b> points + redemption rules
                </>,
                <>
                  Multiple fulfillment models: <b>Home Delivery, Click & Collect, Store Pickup</b>
                </>,
                <>Bulk operations, reporting, exports, and operational automation</>,
                <>
                  Full admin control over <b>UI, content, offers, and workflows</b>
                </>,
              ]}
            />

            <SectionDescription mt="22px">
              In short:{' '}
              <b>{`a normal e-commerce template would look fine, but it wouldn't run the business.`}</b>
            </SectionDescription>

            <Box sx={{ mt: { xs: '40px', md: '72px' }, mb: { xs: '24px', md: '40px' } }}>
              <VideoPlayer
                src={Buildex_video_home}
                autoPlay={true}
                loop={true}
                muted={true}
              />
            </Box>

          </SectionBox>

          <SectionBox mt={{ xs: '50px', md: '100px' }}>
            <SectionDescription mt={0} sx={{ mb: '12px' }}>
              <b>{`The hardest part wasn't launching the website.`}</b>
            </SectionDescription>

            <SectionHeading title="It was designing a system that stays clean for customers while staying controllable for the operations team." />

            <SectionDescription>
              {`When large catalogs, frequent price/stock updates, promotions, taxes, and
                multi-fulfillment all collide, "manual management" becomes the hidden bottleneck.
                That's where Buildex needed an enterprise commerce ecosystem, not a storefront.`}
            </SectionDescription>

            <SectionBox mt={10}>
              <SectionHeading title="We approached this like building a retail operating layer, not a design project." />

              <ListWithHeader
                header="The blueprint: Where simplicity meets power"
                isNumbered
                items={[
                  <>
                    A <b>high-performance storefront</b> built for discovery and conversion
                  </>,
                  <>
                    A <b>high-control Admin Dashboard</b> to run catalog, offers, content, taxes,
                    loyalty, and reports
                  </>,
                  <>
                    <b>Member/Sub-admin panels</b> with permission groups so teams can operate
                    safely at scale
                  </>,
                  <>
                    A <b>rule-based backend</b> that makes taxes, loyalty, preorder/enquiry flows,
                    and fulfillment reliable (no hacks)
                  </>,
                ]}
              />

              <SectionDescription>
                If the system is structured enough for operations, customers will feel it as faster
                browsing, clearer totals, smoother checkout, better trust
              </SectionDescription>

              <FigureWithCaption
                caption="Buildex Dashboard"
                src={startingImage}
                alt="Buildex Dashboard"
                title="Buildex Dashboard"
              />


            </SectionBox>

            <SectionBox mt={{ xs: '72px', md: '72px' }}>
              <SectionTitle variant="xs">
                Storefront built for conversion + product discovery
              </SectionTitle>

              <SectionHeading
                title={`a wide catalog can easily become "hard to browse," which kills conversion.`}
                marginTop={false}
              />

              <ListWithHeader
                header="What we built"
                items={[
                  <>Arabic/English support, SEO-friendly URLs, multi-currency pricing</>,
                  <>
                    Strong merchandising: featured categories, promo banners (image/video/GIF),
                    CMS-driven sections
                  </>,
                  <>
                    {`Confidence builders: breadcrumbs, rich product info, variant images + IDs,
                      related/recently viewed, "Frequently Bought Together"`}
                  </>,
                  <>
                    Smart cart + checkout: real-time cart alerts, EDD per product, coupons/offers,
                    loyalty visibility, tax clarity
                  </>,
                ]}
              />

              <SectionDescription sx={{ fontSize: '16px' }}>
                <b>What changed:</b>
                {` customers stop "hunting" and find products faster, trust the
                  checkout total more, and buy with less friction, especially in a wide-catalog store.`}
              </SectionDescription>

              <Box sx={{ mt: { xs: '40px', md: '72px' }, mb: { xs: '24px', md: '40px' } }}>
                <VideoPlayer
                  src={buildexMobile}
                  autoPlay={true}
                  loop={true}
                  muted={true}
                  isReel
                />
              </Box>


            </SectionBox>

            <SectionBox mt={10}>
              <SectionHeading title="Bank Muscat payment gateway" marginTop={false} />
              <SectionDescription>
                To match real-world checkout expectations in Oman, we integrated the{' '}
                <b>Bank Muscat payment gateway</b> into the Buildex e-commerce platform. This
                enabled secure online payments in OMR with a smooth checkout flow
              </SectionDescription>


            </SectionBox>

            <SectionBox mt={{ xs: '50px', md: '100px' }}>
              <LargeHeading mt={0} mb={3}>
                The Impact
              </LargeHeading>
              <BulletList
                items={[
                  <>
                    <b>Enterprise-ready e-commerce built for Oman</b>: large catalog + bilingual UX +
                    VAT clarity + multi-fulfillment.
                  </>,
                  <>
                    <b>Operational load reduced</b>: bulk updates, reporting exports, and admin
                    automation removed daily friction.
                  </>,
                  <>
                    <b>More conversion confidence</b>: transparent totals, structured discovery, and
                    campaign-ready merchandising.
                  </>,
                  <>
                    <b>Retention built in</b>: loyalty tiers and repeat-buy loops within the customer
                    journey.
                  </>,
                  <>
                    <b>ERP-ready foundation</b>: SAP ID mapping supports future sync and cleaner
                    operations at scale.
                  </>,
                ]}
                mt={0}
              />

              <FigureWithCaption
                src={buildexDashboard1}
                alt="Buildex Payment Gateway"
                title="Buildex Payment Gateway"
                caption="Buildex Payment Gateway"
              />
            </SectionBox>

            {/* <FigureWithCaption
                src={buildexDashboard2}
                alt="Steel window factory workflow diagram - LOHA GRID manufacturing ERP showing product customisation, cost calculation, window quotation generation, production scheduling, and factory workflow management integration"
                title="Steel Window Manufacturing Workflow - Factory Systemisation Software"
                caption="LOHA GRID factory workflow: Integrated steel window manufacturing automation from order entry to production tracking and delivery in Kerala"
              />
              <FigureWithCaption
                src={buildexOrders}
                alt="Steel window factory workflow diagram - LOHA GRID manufacturing ERP showing product customisation, cost calculation, window quotation generation, production scheduling, and factory workflow management integration"
                title="Steel Window Manufacturing Workflow - Factory Systemisation Software"
                caption="LOHA GRID factory workflow: Integrated steel window manufacturing automation from order entry to production tracking and delivery in Kerala"
              /> */}

            <SectionBox mt={10}>
              <SectionHeading title="Occasion-led Sales Hub" marginTop={false} />
              <SectionDescription>
                The Deals page works like a dedicated campaign zone where Buildex can run
                occasion-based offers (seasonal promos, weekend specials, brand days) without
                touching the core storefront.
              </SectionDescription>

              <ListWithHeader
                header="What makes it enterprise-level (and not just a banner):"
                items={[
                  <>
                    Deal-first discovery: customers can browse offers directly from one place
                    instead of hunting product-by-product.
                  </>,
                  <>
                    {`Clear value communication: products show original price → offer price → % off,
                      often presented as a "WOW Deal."`}
                  </>,
                  <>
                    Tax clarity built-in: deal pricing is shown with VAT-inclusive messaging, so
                    customers feel confident at checkout (no surprise totals).
                  </>,
                  <>
                    {`Merchandising tags that sell faster: labels like "WOW Deal" and "New Arrival"
                      help Buildex push urgency and freshness across brands and product groups.`}
                  </>,
                  <>
                    {`Works across wide product groups: since Buildex has a broad catalog, this page
                    becomes the "shortcut" for customers who just want the best offers now`}
                  </>,
                ]}
              />

              <SectionDescription sx={{ fontSize: '16px' }}>
                <b>What changed:</b> Buildex can run seasonal pushes and brand days{' '}
                <b>without touching core UX</b>.
              </SectionDescription>

              <Box sx={{
                mt: { xs: '40px', md: '72px' }, mb: { xs: '24px', md: '40px' },
                borderRadius: "20px",
                cornerShape: 'squircle',

                boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px"
              }}>
                <VideoPlayer
                  src={buildexStorefront}
                  autoPlay={true}
                  loop={true}
                  muted={true}
                  sx={{
                    borderRadius: "20px",
                    cornerShape: 'squircle',
                  }}
                />
              </Box>
            </SectionBox>

            <SectionBox mt={10}>
              <SectionHeading title="SAP ID Mapping (ERP-Ready Foundation)" marginTop={false} />
              <SectionDescription>
                Large retailers lose control when storefront and ERP speak different languages.
              </SectionDescription>
              <SectionDescription>
                We built SAP ID mapping at product/variant level to align with existing SAP ERP
                structures the platform became future-ready for clean ERP sync and reconciliation,
                <b> enterprise alignment, not just SKU tracking</b>.
              </SectionDescription>

              <FigureWithCaption
                src={buildexDashboard}
                alt="Buildex Payment Gateway"
                title="Buildex Payment Gateway"
                caption="Buildex Payment Gateway"
              />
            </SectionBox>

            <SectionBox mt={10}>
              <SectionHeading title="Microservices architecture" marginTop={false} />
              <SectionDescription>
                {`Buildex wasn't built as one big "website." It was built as a microservices-based`}
                commerce system, so the storefront, admin operations, and business-rule engine (VAT,
                loyalty, pickup/delivery, preorder/enquiry) can scale and evolve independently. This
                reduces risk during updates, improves performance under{' '}
                <b>high traffic, and keeps the platform future-ready</b>
              </SectionDescription>
            </SectionBox>

            <SectionBox mt={10}>
              <SectionHeading title="Multi-Fulfillment: Delivery + Pickup" marginTop={false} />
              <SectionDescription>
                convenience decides purchases—especially when customers already have nearby stores.
              </SectionDescription>

              <ListWithHeader
                header="What we built"
                items={[
                  <>Pickup location module (click & collect / store pickup logic)</>,
                  <>Delivery options + pricing configuration</>,
                  <>Admin controls and tracking for pickup orders</>,
                ]}
              />

              <SectionDescription sx={{ fontSize: '16px' }}>
                <b>What changed:</b>
                {` Buildex's offline advantage became an online advantage—buy
                online, collect where convenient.`}
              </SectionDescription>

              <Box sx={{
                mt: { xs: '40px', md: '72px' }, mb: { xs: '24px', md: '40px' },
                borderRadius: "20px",
                cornerShape: 'squircle',
                boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px"
              }}>
                <VideoPlayer
                  src={aklCatagory}
                  autoPlay={true}
                  loop={true}
                  muted={true}
                  sx={{
                    borderRadius: "20px",
                    cornerShape: 'squircle',

                  }}
                />
              </Box>
            </SectionBox>

            <SectionBox mt={10}>
              <SectionHeading
                title="Repeat purchases don't happen automatically. Even trusted brands need a reason to come back."
                marginTop={false}
              />

              <ListWithHeader
                header="What we built"
                items={[
                  <>Loyalty points + configurable tiers and thresholds</>,
                  <>Points visibility in account + redemption rules</>,
                  <>Loyalty-aware campaigns and reporting</>,
                ]}
              />

              <SectionDescription>
                Customers feel a <b>relationship</b> with the store, not a one-time transaction.
              </SectionDescription>

              <FigureWithCaption
                src={buildexOrders}
                alt="Buildex Payment Gateway"
                title="Buildex Payment Gateway"
                caption="Buildex Payment Gateway"
              />
            </SectionBox>

            <SectionBox mt={10}>
              <SectionHeading
                title={`Enterprise e-commerce fails when daily operations require "asking the developer."`}
                marginTop={false}
              />

              <ListWithHeader
                header="What we built"
                items={[
                  <>
                    {`Buildex's homepage wasn't hard-coded. We built it as a{' '}
                    <b>dynamic, CMS-style homepage</b> that the team can update anytime from the
                    admin dashboard—without developer support.`}
                  </>,
                  <>Bulk upload for products, variant stock, and pricing</>,
                  <>Banner, offers, timers, combos, coupons, and content controls</>,
                  <>Role-based permissions (sub-admin/member access by module)</>,
                  <>
                    Export-ready reports (orders, sales, stock, wishlist/cart, loyalty performance)
                  </>,
                ]}
              />

              <SectionDescription sx={{ fontSize: '16px' }}>
                <b>What changed:</b> the business runs with <b>control</b>, not chaos, teams can
                move fast without breaking the system.
              </SectionDescription>


              <Box sx={{ mt: { xs: '40px', md: '72px' }, mb: { xs: '24px', md: '40px' } }}>
                <VideoPlayer
                  src={groupVideo}
                  autoPlay={true}
                  loop={true}
                  muted={true}
                />
              </Box>
            </SectionBox>

          </SectionBox>
        </SectionBox>



        <SectionBox mt={{ xs: '50px', md: '100px' }} mb={'50px'}>
          <LargeHeading mt={0} mb={3}>
            Why This Project Stands Out
          </LargeHeading>
          <BulletList
            items={[
              <>
                <b>Not a template-based store</b>, fully custom, rule-driven architecture
              </>,
              <>
                Built for <b>regional commerce realities</b> (language, tax, logistics options)
              </>,
              <>
                Handles <b>large catalogs + complex variants</b> cleanly
              </>,
              <>
                Enterprise control: <b>roles, permissions, reporting, bulk operations</b>
              </>,
              <>
                Designed to be <b>configurable, secure, and scalable</b> for long-term growth.
              </>,
            ]}
            mt={0}
          />
        </SectionBox>
      </Box>

      <DiscussProjectSection
        title={
          <>
            Need an enterprise <br /> e-commerce ecosystem
          </>
        }
        description="Book a 20-minute consult with Osperb and get a blueprint for your business."
        type={screenWidth > 768 ? 'web' : 'mobile'}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          pt: 10,
          px: 2,
        }}
        maxWidth={E_COMMERCE_STYLES.container.maxWidthWeb}
        margin={E_COMMERCE_STYLES.container.mx}
      >
        <FeaturedCaseStudies
          hideShadow={true}
          isSlider={isMobile ? false : true}
          type={isMobile ? 'mobile' : 'web'}
          projects={featuredProjects}
        />
      </Box>
    </>
  );
};

export default CSBuildex;
